<template>
  <div class="navbar" :class="{ 'navbar-w': navStyle == 1 }">
    <div class="bar">
      <div class="left-bar">
        <div
          class="logo"
          @click="$router.push({ name: 'Home' })"
          v-show="navStyle != 1"
        >
          <img src="../../assets/logo-1.png" />
          <span>农村产权流转交易中心</span>
        </div>
        <div class="area">
          <i class="el-icon-location"></i>
          <el-select
            v-model="area"
            @change="handleArea"
            :popper-append-to-body="false"
            style="margin-right:10px"
          >
            <el-option
              v-for="(item, index) in city"
              :key="index"
              :label="item.areaConfigName"
              :value="item.areaConfigId"
            ></el-option>
          </el-select>
          <el-select
            v-model="sonAreas"
            @change="handleSonAreas"
            v-if="districtList.length > 1"
          >
            <el-option
              v-for="(item, index) in districtList"
              :key="index"
              :label="item.areaConfigName"
              :value="item.areaConfigId"
            ></el-option>
          </el-select>
          <span v-else v-for="(item, index) in districtList" :key="index">{{
            item.areaConfigName
          }}</span>
        </div>
      </div>
      <div class="right-bar" v-if="tokenShow">
<!--        <a class="to-data-a" href="http://www.vpclub.cn/" target="_blank"-->
<!--          >前往大数据平台</a-->
<!--        >-->
        <span
          :class="[
            'state',
            { 'state-true': personVertification === '已认证' },
            { 'state-w': navStyle == 1 },
          ]"
          >{{ personVertification }}</span
        >
        <el-button
          type="text"
          style="display:none"
          @click.stop="$router.push({ name: 'memberManage' })"
          >会员管理</el-button
        >
        <div class="nav-user">
          <el-dropdown @command="profileEvent">
            <span class="el-dropdown-link">
              {{ info }}
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in profileList"
                :key="index"
                :command="item.name"
                >{{ item.meta.name }}</el-dropdown-item
              >
              <el-dropdown-item :command="'signOut'">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-badge :is-dot="commentShow" class="item" type="warning">
          <el-button
            type="text"
            style="padding:0;"
            @click.stop="$router.push({ name: 'myNotice' })"
            >通知中心</el-button
          >
        </el-badge>
      </div>
      <div class="right-bar login" v-else>
<!--        <a class="to-data-a" href="http://www.vpclub.cn/" target="_blank"-->
<!--          >前往大数据平台</a-->
<!--        >-->
        <span @click="toLogin(1)">登录</span>
        <span @click="toLogin(2)">注册</span>
      </div>
    </div>
    <!-- 认证弹窗 -->
    <Dialog
      :show="show"
      @dialogClose="dialogClose"
      :title="'温馨提示'"
      :img="'uncertified.png'"
      :content="'您还未进行身份认证，请先认证'"
      :btn="'去认证'"
    />
  </div>
</template>
<script>
import NavbarItemLink from './NavbarItemLink.vue'
import Dialog from '@/components/Dialog'
import router from '@/router'
import { sessionStore } from '@/utils/data-management'
export default {
  data() {
    return {
      leftRouter: router.options.routes[0].children,
      area: '',
      sonAreas: '',
      city: [],
      districtList: [],
      comment: false,
    }
  },
  components: { NavbarItemLink, Dialog },
  computed: {
    routerFilter() {
      return this.leftRouter.filter((item) => {
        return !item.meta.navbarHidden
      })
    },
    profileList() {
      return this.leftRouter
        .filter((item) => {
          return item.name === 'Profile'
        })[0]
        .children.filter((ele) => {
          return !ele.meta.downHidde;
        })
    },
    info() {
      return this.$store.state.userInfo.name || this.$store.state.userInfo.phone
    },
    personVertification() {
      if (this.$store.state.userInfo) {
        if (this.$store.state.userInfo.personVertification) return '已认证'
      }
      return '未认证'
    },
    tokenShow() {
      if (this.$store.state.token && this.$store.state.token != 'show') {
        return true
      } else {
        return false
      }
    },
    show() {
      return this.$store.state.vertification
    },
    cityArea() {
      return this.$store.state.cityArea
    },
    commentShow() {
      return Boolean(this.$store.state.cnoticeCenter)
    },
    navStyle() {
      let style = 2
      let index = ['home', 'subnav', 'propertyexchangecenter']
      let path = this.$route.path.toLowerCase()
      index.map((item) => {
        if (path.indexOf(item) != -1) {
          style = 1
        }
      })
      return style
    },
  },
  watch: {
    tokenShow: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getDataList()
        }
      },
    },
    '$route':{
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      }
    }
  },
  methods: {
    findKey(arr,key){
      for (let i=0;i<arr.length;i++){
        if(arr[i].areaConfigId===key){
          this.area = arr[i].areaConfigName
          if (arr[i].sonAreas && arr[i].sonAreas.length) {
            this.districtList = arr[i].sonAreas
            this.sonAreas = this.districtList[0].areaConfigName
          } else {
            this.districtList = []
            this.sonAreas = ''
          }
          return arr[i]
        }else {
          if (arr[i].sonAreas && arr[i].sonAreas.length > 0) {
            const res = this.findKey(arr[i].sonAreas, key);
            if (res) {
              this.area = arr[i].city
              this.districtList = arr[i].sonAreas
              this.sonAreas = res.areaConfigName
              return res;
            }
          }
        }
      }
    },
    init() {
      this.$api.my.getAeraAndType({ systemType: 3 }).then((res) => {
        this.city = res.data.aeras
        let city = {}
        this.city.map((item) => {
          if (item.sonAreas && item.sonAreas.length > 1) {
            city = JSON.parse(JSON.stringify(item))
            city.areaConfigName = '全部'
            item.sonAreas.unshift(city)
          }
        })
        let key = ''
        if (this.$route.query.source) {
          key = this.$route.query.source
        } else if (this.cityArea) {
          key = this.cityArea.areaConfigId
        } else {
        }
        if (key) {
          // const a = this.city.find((item) => {
          //   return item.areaConfigId == key
          // })
          const a = this.findKey(this.city,key)
          if (a) {
            this.$store.dispatch('changeArea', a)
          } else {
            this.city.map((item) => {
              if (item.areaConfigName == this.cityArea.city) {
                this.area = item.areaConfigName
                this.districtList = item.sonAreas
              }
            })
            if (this.districtList && this.districtList.length > 0) {
              this.districtList.map((item) => {
                if (item.areaConfigId == key) {
                  this.$store.dispatch('changeArea', item)
                  this.sonAreas = item.areaConfigName
                }
              })
            }
          }
        } else {
          if(this.city[0].sonAreas.length===1){
            this.$store.dispatch('changeArea', this.city[0].sonAreas[0])
          }else {
            this.$store.dispatch('changeArea', this.city[0])
          }
          this.area = this.city[0].areaConfigName
          this.districtList = this.city[0].sonAreas
          this.sonAreas = this.districtList[0].areaConfigName
        }
      })
    },
    getDataList() {
      this.$api.my
        .noticeList({
          userId: this.$store.state.userInfo.id,
          type: 2,
          pageNumber: 0,
        })
        .then((res) => {
          if (res.code == 1000) {
            let read = res.data.filter((item) => item.isRead != 1)
            if (read.length > 0) {
              this.comment = true
            }
            this.$store.dispatch('cnoticeCenter', this.comment)
          }
        })
        .catch((err) => {})
    },
    profileEvent(bundle) {
      if (bundle === 'managementPersonal') {
        this.$goTo(bundle)
      }
      if (bundle === 'signOut') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStore.remove('userInfo')
          sessionStore.remove('zctToken')
          this.$store.dispatch('getUserInfo')
          this.$store.dispatch('cnoticeCenter', false) //--7
          if (sessionStore.get('ticket')) {
            const host = window.location.host
            if (host == 'rural.zct.gjsc.info') {
              window.location.replace(
                  'http://one.baise.vpclub.cn/#/home/workHall'
              )
            } else if (host == 'rural.baise.gjsc.info') {
              window.location.replace(
                  'http://one.baise.gjsc.info/#/home/workHall'
              )
            } else if (host.indexOf('fusui') != -1) {
              window.location.replace(
                  'https://identity.gxfusui.com/#/home/workHall'
              )
            } else if (host == 'jyzx.gxfusui.com') {
              // http://jyzx.gxfusui.com/#/home
              window.location.replace(
                  'https://identity.gxfusui.com/#/home/workHall'
              )
            } else {
              window.location.replace(
                  'http://baise-portal-pc.baise.whdev.vpclub.cn/#/home/workHall'
              )
            }
          } else {
            this.$store.dispatch('getToken', '')
            this.$router.push({
              name: 'Home',
              query: { source: this.cityArea.areaConfigId },
            })
          }
        }).catch(() => {
        });
        return
      }
      if (this.$store.state.userInfo.personVertification) {
        this.$goTo(bundle)
      } else {
        // 未认证
        if (bundle !== 'managementPersonal')
          return (this.$store.state.vertification = true)
      }
    },
    toManagement() {
      if (this.$store.state.accountType === '1') {
        this.$router.push({ name: 'managementPersonal' })
      } else {
        this.$router.push({ name: 'managementBusiness' })
      }
    },
    dialogSumbitL() {
      this.$store.state.vertification = false
      this.$router.push('/managementPersonal?status=1')
    },
    handleArea(e) {
      window.scrollTo(0, 0)
      let area = {}
      this.city.map((item) => {
        if (item.areaConfigId == e) {
          if(item.sonAreas&&item.sonAreas.length===1){
            area = item.sonAreas[0]
          }else {
            area = item
          }
          if (item.sonAreas && item.sonAreas.length > 0) {
            this.districtList = item.sonAreas
            this.sonAreas = this.districtList[0].areaConfigName
          } else {
            this.districtList = []
            this.sonAreas = ''
          }
        }
      })
      this.$store.dispatch('changeArea', area)
      this.$router.push({
        name: 'Home',
        query: { source: this.cityArea.areaConfigId },
      })
    },
    handleSonAreas(e) {
      window.scrollTo(0, 0)
      this.districtList.map((item) => {
        if (item.areaConfigId == e) {
          this.$store.dispatch('changeArea', item)
        }
      })
      this.$router.push({
        name: 'Home',
        query: { source: this.cityArea.areaConfigId },
      })
    },
    goTo(e) {
      // console.log(e, "go", this.$store.state.cityArea);
      if (e == this.$store.state.cityArea) {
        window.scrollTo(0, 0)
        this.$router.push({
          name: 'Home',
          query: { source: this.cityArea.areaConfigId },
        })
      }
    },
    toLogin(show) {
      this.$router.push({
        name: 'Home',
        query: { source: this.cityArea.areaConfigId },
      })
      this.$store.dispatch('getToken', 'show')
      sessionStore.set('toLoginTypeRPRT', show)
    },
    dialogClose() {
      this.$store.state.vertification = false
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.to-data-a {
  padding-right: 30px;
  text-decoration: none;
  color: #e6a23c;
}
.navbar {
  min-width: 1200px;
  height: 48px;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  background: #0e8959;
  background-size: 100% 100%;

  .bar {
    display: flex;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
  }

  .left-bar {
    height: 100%;
    font-size: 0;
    line-height: 48px;
    font-size: 14px;
    display: flex;
    align-items: center;
    .logo {
      width: 220px;
      display: flex;
      cursor: pointer;
      align-items: center;
      img {
        // height: 100%;
        width: 44px;
        height: 44px;
      }
      span {
        font-size: 17px;
        font-weight: 550;
        position: relative;
        left: 5px;
        color: #fff;
      }
    }
    a {
      font-size: 14px;
      font-weight: 400;
      color: #222222;
      color: #fff;
      margin: 0 20px;
      padding: 0 10px;
      text-decoration: none;
      position: relative;
      &::before {
        content: ' ';
        position: absolute;
        width: 1px;
        height: 12px;
        background: #ebecef;
        left: -20px;
        top: 50%;
        transform: translateY(-50%);
      }
      &:nth-of-type(1) {
        &::before {
          display: none;
        }
      }
    }
  }

  .right-bar {
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 20px;
    .nav-user {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 10px;
      .el-dropdown {
        color: #fff;
      }
      .el-dropdown-link {
        cursor: pointer;
      }
    }
    .el-button {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      color: #fff;
    }
    .user-status {
      font-size: 12px;
      color: #22C686;
      cursor: pointer;
    }
    .state {
      width: 50px;
      line-height: 18px;
      text-align: center;
      border-radius: 3px;
      color: #22C686;
      background: #f3fafa;
      font-size: 12px;
    }
    .state-true {
      color: #894e01;
      background: #ffefda;
    }
  }
  .login {
    color: #fff;
    span {
      line-height: 13px;
      padding: 0 10px;
      cursor: pointer;
    }
    span:first-child {
      border-right: 1px solid #fff;
    }
  }
}
.navbar-w {
  background: #0e8959;
  .right-bar {
    .state-w {
      color: #22C686;
      border: 1px solid #22C686;
      background: none;
    }
    .nav-user {
      .el-dropdown {
        color: #fff;
      }
    }
    .el-button {
      color: #fff;
    }
  }
  .login {
    color: #fff;
    span:first-child {
      border-color: #394259;
    }
  }
  .area {
    i {
      color: #22C686;
      font-size: 18px;
      top: 2px;
    }
    .el-select {
      /deep/ .el-input__inner {
        color: #fff;
        background: #106745;
      }
      /deep/ .el-input .el-select__caret {
        color: #fff;
      }
      /deep/ .el-icon-arrow-up:before {
        content: '\e78f';
      }
      /deep/ .el-input__icon:after {
        height: 105%;
      }
    }
    span {
      color: #fff;
    }
  }
}

.area {
  color: #fff;
  i {
    color: #fff;
    position: relative;
    left: 20px;
    z-index: 2;
  }
  .el-select {
    width: 115px;
    /deep/ .el-input__inner {
      height: 30px;
      padding-left: 30px;
      color: #fff;
      background: #106745;
      border-width: 0;
      border-radius: 5px;
    }
    /deep/ .el-input .el-select__caret {
      color: #fff;
    }
    // /deep/ .el-select-dropdown {
    //   width: 262px;
    // }
    /deep/ .el-select-dropdown__wrap {
      max-height: 460px;
      .el-select-group__title {
        color: red;
      }
    }
  }
}
</style>
